import React from 'react';
import { Outlet } from 'react-router-dom';

import { MembershipProvider } from '../contexts/MembershipServiceContext';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material';

const StyledContainer = styled(Container)(() => ({
	display: 'flex',
	direction: 'column',
	width: '100%',
	marginTop: '20px',
	overflow: 'hidden',
	justifyContent: 'center'
}));

const Layout = () => {
	return (
		<React.Fragment>
			<MembershipProvider>
				<StyledContainer>
					<Stack width='800px' direction='column'>
						<Outlet />
					</Stack>
				</StyledContainer>
			</MembershipProvider>
		</React.Fragment>
	);
};

export default Layout;
